<template>
  <div>
    <div
      :class="{
        'line-progress': showAction,
      }"
    >
      <a-progress
        :showInfo="false"
        :strokeColor="{
          '0%': '#375FE2',
          '100%': '#ED40FD',
        }"
        :percent="percent"
        class="progress"
      />
      <template v-if="showAction">
        <slot name="action"></slot>
      </template>
    </div>
    <div class="flex-between text-[12px] -mt-[5px]">
      <div class="flex-y-center gap-[5px]">{{ name }} <slot name="icon"></slot></div>
      <div class="truncate">
        <slot name="data"></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { USER_LEVEL_KEY } from '~/api/interface';
import { USER_ADMIN } from '~/constants';

const props = defineProps<{
  name: string;
  total: number;
  left: number;
}>();

const userInfo = useUserInfo();

const percentColor = {
  ten: '#FF5656',
  five: '#CA0000',
  twenty: '#FFB53D',
  normal: 'rgb(105, 98, 255)',
  storage: '#29D8E2',
};
const isAdmin = computed(
  () =>
    Number(userInfo.value?.permission) !== USER_ADMIN.NORMAL &&
    ![USER_LEVEL_KEY.TASTE, USER_LEVEL_KEY.TEAM_TASTE].includes(
      Number(userInfo.value?.rights_type),
    ),
);

const percent = computed(() => (props.left / props.total) * 100);

const showAction = computed(() => {
  return isAdmin.value;
});

const colors = computed(() => {
  if (percent.value < 80) {
    return percentColor.storage;
  }
  if (percent.value >= 95) {
    return percentColor.five;
  }
  if (percent.value >= 90) {
    return percentColor.ten;
  }
  return percentColor.twenty;
  // }
});
</script>

<style lang="scss" scoped>
.line-progress {
  @apply flex-y-center cursor-pointer;
  .action {
    display: block;
  }
  .progress {
    margin-right: 0;
  }
}
</style>
